import React, { useState, useEffect } from "react";

// libraries
import { get, isEmpty } from "lodash";
import PropTypes from "prop-types";

// Components
import IkTable from "@Components/IkTable";
import IKModal from "@Components/IkModal";

// redux
import { connect } from "react-redux";

// Utils
import dataHandler from "@Utils/dataHandler";

// Modals
import FilterForm from "./FilterModal";

// Styles
import styles from "./styles.module.css";

// static data
import options from "../../staticData";

const ActionUserCrud = ({ tableValue, onClose, dispatch, userName, companyName, newParams }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const defaultParams = { page: 1, orderKey: "startDate", orderDir: "desc", rows: 20 };
	const [lastParams, setLastParams] = useState(defaultParams);
	const [openFilter, setOpenFilter] = useState(false);
	const [estado, setEstado] = useState([]);
	const today = new Date().toISOString().split("T")[0];
	const [fechaEstado, setFechaEstado] = useState(today);
	const [fechaEnd, setFechaEnd] = useState("");

	const id = get(tableValue, "id", "");

	// useEffect
	useEffect(() => {
		(async () => {
			let params = {};
			if (!isEmpty(newParams)) {
				const currentNewParams = parseParams(newParams);
				const defineParams = {
					...(currentNewParams.startDate ? { startDate: currentNewParams.startDate } : {}),
					...(currentNewParams.state ? { state: currentNewParams.state } : {}),
				};
				// setLastParams({ ...lastParams, ...defineParams });
				params = { ...lastParams, ...defineParams };
			}
			const companyUsersPromese = await dataHandler({
				dispatch,
				url: `companyUsers/${id}`,
				params,
			});

			const [companyUserResponce] = await Promise.all([companyUsersPromese]);

			setFilteredCount(companyUserResponce.count);
			setFilteredItems(companyUserResponce.items);
		})();
	}, []);
	// modal
	const cancelModal = () => {
		onClose();
	};

	const parseParams = (params) => {
		const parsed = {};

		Object.entries(params).forEach(([key, value]) => {
			const parsedKey = key.includes(".") ? key.split(".").pop() : key;
			parsed[parsedKey] = value;
		});

		return parsed;
	};

	// data handlers
	const handlerData = async (params, printable) => {
		const newCurrentParams = { ...params };
		const parsedParams = parseParams(newCurrentParams);
		const useParams = omitFilterEmpty(parsedParams);
		const data = await dataHandler({ dispatch, url: `companyUsers/${id}`, params: { ...useParams } });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}
		setLastParams({ ...useParams });
	};

	const handleRefreshData = async () => {
		let params = {};
		// const currentParams = lastParams;
		// const currentNewParams = parseParams(currentParams);
		// const defineParams = {
		// 	...currentNewParams,
		// 	...(currentNewParams.startDate ? { startDate: currentNewParams.startDate } : {}),
		// 	...(currentNewParams.state ? { state: currentNewParams.state } : {}),
		// };
		params = { ...lastParams };

		const companyUsersPromese = await dataHandler({
			dispatch,
			url: `companyUsers/${id}`,
			params,
		});

		const [companyUserResponce] = await Promise.all([companyUsersPromese]);

		setFilteredCount(companyUserResponce.count);
		setFilteredItems(companyUserResponce.items);
		// setLastParams({ ...lastParams });
	};

	const onFilter = async (params) => {
		const updatedParams = omitFilterEmpty(params);
		const currentParams = { ...updatedParams };
		const finalParams = isEmpty(updatedParams) ? defaultParams : currentParams;

		const parsedParams = parseParams(finalParams);
		const defineParams = {
			...(parsedParams.startDate ? { startDate: parsedParams.startDate } : {}),
			...(parsedParams.state ? { "state[]?": parsedParams.state } : {}),
		};

		const companyUsersPromese = await dataHandler({
			dispatch,
			url: `companyUsers/${id}`,
			params: { ...parsedParams, ...defineParams },
		});

		setFilteredCount(companyUsersPromese.count);
		setFilteredItems(companyUsersPromese.items);
		setLastParams(finalParams);
	};

	const omitFilterEmpty = (params) => {
		const updatedParams = { ...params };

		Object.keys(params).forEach((key) => {
			const value = params[key];

			if (value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0)) {
				delete updatedParams[key];
			} else {
				updatedParams[key] = value;
			}
		});
		return updatedParams;
	};

	const handleChangeOption = () => {
		setOpenFilter(true);
	};

	return (
		<IKModal
			title={`Historial de Estado: ${get(tableValue, "user.fullName", "")}`}
			onClose={cancelModal}
			id={get(tableValue, "companyusersId", "")}
			fullHeight
			onSuccess={null}
			size="large">
			<div className={styles.grid}>
				<fieldset className={styles.fieldset}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Estado",
									key: "state",
									format: "string",
									width: 1,
								},
								{
									label: "Inicio",
									key: "startDate",
									format: "dateTime",
									width: 1,
								},
								{
									label: "Fin",
									key: "endDate",
									format: "dateTime",
									canFilter: false,
									width: 2,
								},
								{
									label: "Transcurrido",
									key: "startDate",
									endDateKey: "endDate",
									format: "timeBetween",
									canFilter: false,
									dataPosition: "left",
									headerPosition: "left",
									width: 15,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={lastParams}
							dataHandler={handlerData}
							// handlerTable={handleButton}
							searcher={{ width: "40rem", filterButton: false }}
							topButtons={[
								{
									componentType: "Button",
									content: "Filtrar",
									icon: "filter",
									buttonContainerStyle: styles.filterButton,
									onClick: handleChangeOption,
									className: styles.buttonFilterTable,
								},
								{
									icon: "refresh",
									className: styles.refreshButton,
									// componentType: "",
									onClick: () => {
										handleRefreshData();
									},
								},
							]}
							print={{
								printHeader: {
									company: companyName,
									title: `Historial de Estado: ${get(tableValue, "user.fullName", "")}`,
									user: userName,
								},
							}}
						/>
					</div>
				</fieldset>
			</div>
			{openFilter && (
				<FilterForm
					onClose={() => {
						setOpenFilter(false);
					}}
					onFilter={onFilter}
					estado={estado}
					setEstado={setEstado}
					fechaEstado={fechaEstado}
					setFechaEstado={setFechaEstado}
					stateOptions={options}
					isUserAction
					fechaEnd={fechaEnd}
					setFechaEnd={setFechaEnd}
					agentName={get(tableValue, "user.fullName", "")}
					today={today}
				/>
			)}
		</IKModal>
	);
};

ActionUserCrud.propTypes = {
	userName: PropTypes.string,
	companyName: PropTypes.string,
	tableValue: PropTypes.object,
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	// modalMode: PropTypes.string,
	newParams: PropTypes.object,
};

function mapStateToProps() {
	return {};
}
export default connect(mapStateToProps)(ActionUserCrud);
